/**
 * Writes a price with exactly the number of decimals its currency uses.
 *
 * A Jordanian dinar is written with three: `2.750`, and the trailing zero is
 * part of the price, not noise. JavaScript cannot carry it — `2.750` and `2.75`
 * are the same number — so the zero has to be put back at the point of display.
 *
 * Always pads, so a whole number reads as money rather than a count: `5`
 * becomes `5.000` in JOD and `5.00` in SAR.
 *
 * Returns an empty string for a missing price, so a caller can render nothing
 * rather than `0.000`.
 */
export function formatPrice(
  value: number | string | null | undefined,
  decimals: number
): string {
  if (value === null || value === undefined || value === "") return "";

  const amount = typeof value === "string" ? Number(value) : value;
  if (!Number.isFinite(amount)) return "";

  return amount.toFixed(decimals);
}
